import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  applicationVersion: 'nv3.7',
  applicationName: 'NDNQIWrapper',
  environment: 'PROD',

  // Security
  UseCookies: true,
  CookieName: 'NdnqiToken',
  CookieDomain: 'members.nursingquality.org',
  CookiePath: '/ndnqiwrapper',
  UseTestToken: false,
  UseTestHospital: false,
  UseTestProduct: false,
  StorageID: 'indicator-factory-store',
  PendoUserID: 'indicator-factory-pendo-userid',
  FederationTokenID: 'federation-token',
  AccessTokenID: 'indicator-factory-token',
  TokenIDExpires: 'indicator-factory-token-expires',
  TokenEmail: 'indicator-factory-token-email',
  TokenUserRole: 'indicator-factory-token-role',
  TokenRefreshPeriod: 1,
  TimeoutDialogDuration: 1020,
  TimeoutDecisionTime: 30,
  TimeoutCounterDisplayEnabled: false,
  UserHospId: 'indicator-factory-userhospid',
  TokenSubscriptionsAvailable: 'indicator-factory-token-subscriptionsavailable',
  SubscriptionSelected: 'indicator-factory-subscription-selected',

  WebServer: 'https://members.nursingquality.org',
  PortalWebServer: 'https://members.nursingquality.org/NDNQIPortal',
  IndicatorWebServer: 'https://members.nursingquality.org/IndicatorFactory',
  ValidationWebServer: 'https://members.nursingquality.org/ValidationEngineClient',
  PerformanceWebServer: 'https://members.nursingquality.org/PerformanceReportsClient',
  SystemManagementWebServer: 'https://members.nursingquality.org/SystemManagementClient',
  LearningManagementWebServer: 'https://members.nursingquality.org/LearningManagementClient',
  NdnqiPublicReportsWebServer: 'https://members.nursingquality.org/NdnqiPublicReportsClient',
  NdnqiFoundationWebServer: 'https://members.nursingquality.org/NdnqiFoundationClient',
  GenerateSamlResponsePage: 'https://members.nursingquality.org/ndnqiportal/sso/GenerateSamlResponse.aspx',
  LoginPage: 'https://members.nursingquality.org/ndnqiportal/login2/LogIn.aspx?LoggedOut=True',
  LoggedOutPage: '/ndnqiwrapper/assets/static/loggedout.html',
  IndicatorFactoryLogoutPage: 'https://members.nursingquality.org/IndicatorFactory/logout',
  LogoutPage: 'https://members.nursingquality.org/ndnqiportal/login2/LogOut.aspx',
  EmptyPage: `/ndnqiwrapper/assets/static/empty-page.html`,
  BlankPage: 'about:blank',
  PortalBlankPage: 'https://members.nursingquality.org/ndnqiportal/BlankPage.aspx',
  IndicatorFactoryClientBlank: 'if/indicatorfactory/blank',
  PortalSessionPage: 'https://members.nursingquality.org/ndnqiportal/PortalSession.aspx',
  PortalSessionPath: 'if/NDNQIPortal/PortalSession.aspx',
  DashboardPath: 'if/indicatorfactory/dashboard',
  EnableIndicatorResolver: true,
  IndicatorResolverPath: 'if/indicatorfactory/indicatorresolver',
  PirResolverPath: 'if/indicatorfactory/indicators/pirresolver',
  PortalTransferPage: 'https://members.nursingquality.org/ndnqiportal/TransferPage.aspx',

  HomePermId: 's0_p0',
  SystemReportsPermId: 's0_p88888888',
  RequestFacilityAccess: 's0_p99999999',
  UserProfilePage:       's0_p55555555',
  SystemManagementPermId: 's79sma',
  IndicatorDocumentSuffix: '_m352_a0',
  IndicatorTutorialSuffix: '_m50_',
  IndicatorOverviewSuffix: '_m127_a0',

  //Flags
  EnableBreadcrumbSwitcher: true,
  EnableSingleSignOn: true,
  EnableNotifications: true,
  EnableHigherLogic: true,
  EnableHuddleBoard: false,
  EnableFacilityDemographicsModal: false,
  enableServiceWorker: false,
  enableGlobalNavigationHeader: true,
  SingleSignonTitle: '',
  HuddleBoardName: 'HUDDLE',
  HuddleBoardTitle: 'Huddle Board',
  HuddleBoardDesc: 'Cross-product performance dashboard to assess risk and identify improvement opportunities',
  HuddleBoardUrl: 'https://prodCNR.iround.pressganey.com/api/SSOAuth/ACS',

  // Storage
  NavLinksID: 'navigation-links-store',
  HospitalId: 'indicator-factory-hospid',
  HospitalName: 'indicator-factory-hospname',
  UnitId: 'indicator-factory-unitid',
  UnitName: 'indicator-factory-unitname',
  IndicatorId: 'indicator-factory-indid',
  IndicatorLink: 'indicator-factory-link',
  PortalLink: 'ndnqi-portal-link',
  CommunitiesId: 'user-communities',

  // API's
  // Api: '/api/',
  // BusinessApi: '/api/business/',
  BusinessApi: 'https://members.nursingquality.org/apis/NDNQINavBusiness/api/business/',
  FederationApi: 'https://members.nursingquality.org/apis/ClinicalFederationBusinessApi/api/v1/business/',
  Assets: 'assets/',
  LocalJsonApi: 'assets/json/',
  TokenServiceApi: 'https://members.nursingquality.org/apis/NDNQIToken/api',
  HospitalChangeServiceApi: 'https://members.nursingquality.org/apis/NDNQIToken/api',

  // SignalR Service
  UseNotificationMessageService: false,
  UseNotificationMenuService: false,
  NotificationMessageService: 'https://members.nursingquality.org:5627/notify',
  NotificationMenuService: 'https://members.nursingquality.org:5627/navigationmenu',

  // Logging
  LogService: 'https://members.nursingquality.org/apis/CentralizedLoggingAPI/api/log/LogData',
  LogMedia: 'application/pg.centralizedloggingapi.logobject+json',
  LogLevel: NgxLoggerLevel.WARN,
  ServerLogLevel: NgxLoggerLevel.WARN,
  DisableConsoleLogging: true,
  TraceLoggingEmails: ['peter.halsall@pressganey.com', 'anb9282@nyp.org', 'meq9001@nyp.org'],

  // Services
  UseServerForUserNavigation: true,
  UseServerForUserRegistration: true,
  UseServerForClinicalUserRegistration: true,
  UseServerForFederation: true,
  // UseHospitalChangeService: true,
  UseServerForIndicatorResolver: true,
  UseServerForHospitalDemographicContent: true,
  UseLocalCacheNavStub: false,

  // Media
  GetMenuHospitalListMedia: 'application/pg.ndnqinavbusinessapi.getmenuhospitalslist+json',
  GetNavigationMedia: 'application/pg.ndnqinavbusinessapi.getmenuitemsbyuserid+json',
  GetNavigationCompressedMedia: 'application/pg.ndnqinavbusinessapi.getmenuitemsbyuseridzip+json',
  GetNavigationUnCompressedMedia: 'application/pg.ndnqinavbusinessapi.getmenuitemsbyuseridunziptext+json',
  GetMenuHospitalItemsMedia: 'application/pg.ndnqinavbusinessapi.getmenuhospitalitems+json',

  NonCacheNavHospitalListMedia: 'application/pg.ndnqinavbusinessapi.gethospitalslist+json',
  NonCacheNavHospitalItemsMedia: 'application/pg.ndnqinavbusinessapi.gethospitalnavigation+json',

  MinNonCacheNavHospitalListMedia: 'application/pg.ndnqinavbusinessapi.getminhospitalslist+json',
  MinNonCacheNavHospitalItemsMedia: 'application/pg.ndnqinavbusinessapi.gethospitalminnavigation+json',

  GetCacheNav: 'application/pg.ndnqinavbusinessapi.getcachenavbyauthusermintext+json',
  GetCacheNavGZip: 'application/pg.ndnqinavbusinessapi.getcachenavbyauthusermintextgzip+json',
  GetCacheNavByAuthUserMinTextGZIP1: 'application/pg.ndnqinavbusinessapi.getcachenavbyauthusermintextgzip1+json',
  GetCacheNavGZipBytes: 'application/pg.ndnqinavbusinessapi.getcachenavbyauthusermintextgzipbytes+json',

  GetDemographicContentMedia: 'application/pg.ndnqinavbusinessapi.getdemographicsbyfacility+json',

  TokenServiceMedia: 'application/json',

  // Navigation Menu
  UseMenuExtension: true,
  TryFullMenu: true,
  MaxNumberOfHospitals: 0,
  MaxNumberOfUnits: 10,

  // New Pressure Injuries and Restraints
  PressureInjuriesAndRestrainstsIndicatorId: 75,
  PressureInjuriesIndicatorId: 74,
  RestraintsIndicatorId: 73,
  // Old Pressure Injuries and Restraints
  PressureInjuriesAndRestrainstsIndicatorId2: 72,
  PressureInjuriesIndicatorId2: 66,
  RestraintsIndicatorId2: 65
};
